import {quizActions, useQuiz} from "../../providers/QuizProvider.tsx";

interface CheckboxQuestionProps {
    name: string;
    label: string;
    options: string[];
    required?: boolean;
}

const CheckboxQuestion = ({name, label, options, required = false}: CheckboxQuestionProps) => {
    const {state, dispatch} = useQuiz();
    const selectedValues = (state.formData[name] as string[]) || [];

    const handleChange = (option: string) => {
        let newValues: string[];
        if (selectedValues.includes(option)) {
            // Remove if already selected
            newValues = selectedValues.filter(v => v !== option);
        } else {
            // Add if not selected
            newValues = [...selectedValues, option];
        }
        dispatch(quizActions.updateFormData({[name]: newValues}));
    };

    return (
        <div className="mb-6">
            <label className="block text-sm font-medium mb-3">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className="space-y-2">
                {options.map((option) => (
                    <label
                        key={option}
                        className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                    >
                        <input
                            type="checkbox"
                            checked={selectedValues.includes(option)}
                            onChange={() => handleChange(option)}
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                        />
                        <span className="ml-3 text-gray-700">{option}</span>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default CheckboxQuestion;
